import React from "react";
import {
    SearchContainer,
    SearchContainerImage,
    SearchContainerInput,
} from "./style.js";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { FetchSearch } from "../../../Actions/productAction";
import { useHistory } from "react-router-dom";

const schema = yup.object().shape({
    data: yup.string().required(),
});

export default function Search({ open }) {
    const history = useHistory();
    const { register, handleSubmit } = useForm({
        resolver: yupResolver(schema),
    });
    const dispatch = useDispatch();

    const onSubmit = (data) => {
        history.push("/product/search");
        dispatch(FetchSearch(data.data));
    };

    return (
        <SearchContainer onSubmit={handleSubmit(onSubmit)} open={open}>
            <SearchContainerImage
                className="image-search"
                src="/svg/loupe.svg"
                alt="searchSvg"
            />
            <SearchContainerInput
                type="text"
                placeholder="Type something"
                {...register("data", { required: true })}
            />
        </SearchContainer>
    );
}

Search.propTypes = {
    open: PropTypes.bool,
};
